// API
// ----------------------------------------------------------------------

import { paths } from '@src/routes/paths';

import packageJson from '../package.json';

export const HOST_API = import.meta.env.VITE_HOST_API;
export const ASSETS_API = import.meta.env.VITE_ASSETS_API;

export const APP_VERSION = import.meta.env.VITE_APP_VERSION || packageJson.version;

export const FIREBASE_API = {
  apiKey: import.meta.env.VITE_FIREBASE_API_KEY,
  authDomain: import.meta.env.VITE_FIREBASE_AUTH_DOMAIN,
  projectId: import.meta.env.VITE_FIREBASE_PROJECT_ID,
  storageBucket: import.meta.env.VITE_FIREBASE_STORAGE_BUCKET,
  messagingSenderId: import.meta.env.VITE_FIREBASE_MESSAGING_SENDER_ID,
  appId: import.meta.env.VITE_FIREBASE_APPID,
  measurementId: import.meta.env.VITE_FIREBASE_MEASUREMENT_ID,
};

export const AMPLIFY_API = {
  userPoolId: import.meta.env.VITE_AWS_AMPLIFY_USER_POOL_ID,
  userPoolWebClientId: import.meta.env.VITE_AWS_AMPLIFY_USER_POOL_WEB_CLIENT_ID,
  region: import.meta.env.VITE_AWS_AMPLIFY_REGION,
};

// Login itself goes through the API (Strapi). These identify the same Auth0 application
// the API uses, and are only needed for logout and the hosted security pages.
export const AUTH0_API = {
  clientId: import.meta.env.VITE_AUTH0_CLIENT_ID,
  domain: import.meta.env.VITE_AUTH0_DOMAIN,
};

export const MAPBOX_API = import.meta.env.VITE_MAPBOX_API;

// ROOT PATH AFTER LOGIN SUCCESSFUL
export const PATH_AFTER_LOGIN = paths.dashboard.user_after_login.index;

export const LOCAL_STORAGE_KEYS = {
  auth: 'auth',
  config: 'config',
  /** Stores the last-seen API config version — used to detect when to bust other caches */
  config_version: 'config_version',
  permissions: 'permissions',
  feature_flags: 'feature_flags',
};

export const DEFAULT_ROWS_OPTIONS_PER_PAGE = [5, 10, 25];
